import { render, staticRenderFns } from "./search-reviews.vue?vue&type=template&id=035224a7"
import script from "./search-reviews.vue?vue&type=script&lang=ts"
export * from "./search-reviews.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports